import type { GameInfo } from "@/lib/api";
import { teamAbbr } from "@/lib/rule-display";
import { cn } from "@/lib/utils";

/**
 * Compact game line used on rule and notification cards.
 * `demo` marks fixture data shown because older notifications do not include
 * game scores yet.
 */
export function GameLine({
	game,
	demo,
	className,
}: {
	game: GameInfo;
	demo?: boolean;
	className?: string;
}) {
	const awayLeads =
		game.awayScore !== null &&
		game.homeScore !== null &&
		game.awayScore > game.homeScore;
	const homeLeads =
		game.awayScore !== null &&
		game.homeScore !== null &&
		game.homeScore > game.awayScore;

	return (
		<span
			className={cn(
				"type-data inline-flex flex-wrap items-center gap-2 text-muted-foreground",
				className,
			)}
		>
			<span className={cn(awayLeads && "font-semibold text-foreground")}>
				{teamAbbr(game.awayTeam)} {game.awayScore ?? "–"}
			</span>
			<span className={cn(homeLeads && "font-semibold text-foreground")}>
				{teamAbbr(game.homeTeam)} {game.homeScore ?? "–"}
			</span>
			{game.clock && <span aria-hidden>·</span>}
			{game.clock && <span>{game.clock}</span>}
			{demo && (
				<span className="rounded-sm bg-muted px-1 py-0.5 text-[0.5625rem] tracking-wide uppercase">
					Demo
				</span>
			)}
		</span>
	);
}
